import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-wrap" }

import { ref, onMounted, reactive } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { addConsult } from '@/api'
import { ElMessage } from "element-plus";
import DropDown from '@/components/DropDown.vue'
import BannerC from '@/components/BannerC.vue';
import { asynchronousRetrieval } from '@/utils'
import { useRouter } from 'vue-router';

interface RuleForm {
  name: string
  companyName: string
  phone: string
  message: string
  consultType: any
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CounsellingView',
  setup(__props) {

const router = useRouter()
const loadUrl: any = ref({})

const data = ref([
  {
    name: '硬件品牌方',
    value: 1
  },
  {
    name: '渠道端/零售终端',
    value: 2
  },
  {
    name: 'B/G端需求方',
    value: 3
  },
  {
    name: '其它',
    value: 4
  },
])
const ruleFormRef = ref<FormInstance>()
const ruleForm: any = reactive<RuleForm>({
  name: '',
  companyName: '',
  phone: '',
  message: '',
  consultType: null
})

const verifyPhoneNumber = (rule: any, value: any, callback: any) => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  if (!reg.test(value.replace(/\s+/g, ""))) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

const rules = reactive<FormRules<RuleForm>>({
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  companyName: [
    { required: true, message: '请输入公司名', trigger: 'blur', }
  ],
  phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: verifyPhoneNumber, trigger: 'blur' }],
  consultType: [{ required: true, message: '请选择伙伴类型', trigger: 'blur', }],
})

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      addConsult({ ...ruleForm, appId: 1 }).then((res) => {
        ElMessage({
          message: '感谢您的反馈!',
          type: "success",
          duration: 2000,
        })
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

onMounted(() => {
  const pageQuery: any = router.currentRoute.value.query;
  ruleForm.consultType = +pageQuery.type || null;
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "form-wrap-title" }, "合作咨询", -1)),
      _createElementVNode("div", {
        class: "form-content-m",
        onClick: _withModifiers(($event: any) => (null), ["stop"])
      }, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm,
          rules: rules,
          "require-asterisk-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "伙伴类型",
              prop: "consultType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: ruleForm.consultType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.consultType) = $event)),
                  placeholder: "请选择资源类型",
                  class: "select-default",
                  "popper-class": "select-option"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              style: {"margin-top":"20rem"},
              label: "姓名",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: ruleForm.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.name) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司名称",
              prop: "companyName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: ruleForm.companyName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.companyName) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "电话",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: ruleForm.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.phone) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "留言",
              prop: "message"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  type: "textarea",
                  modelValue: ruleForm.message,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.message) = $event)),
                  placeholder: "请输入",
                  resize: "none"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "form-submit" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "btn-primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, " 提交信息 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}
}

})